import axios from 'axios';
import ConfigAxios from './ConfigAxios';

const getAllUsers = () => {
  let { NERTHUS, options } = ConfigAxios();
  return axios.get(NERTHUS + '/inbursa/inbursaUsers', options);
};

const getUserById = dataClientId => {
  let { NERTHUS, options } = ConfigAxios();
  return axios.get(NERTHUS + '/inbursa/inbursaUsers/code/' + dataClientId, options);
};

const createUser = dataClient => {
  let { NERTHUS, options } = ConfigAxios();
  return axios.post(NERTHUS + '/inbursa/inbursaUsers', dataClient, options);
};

const updateUser = (dataClient, dataClientId) => {
  let { NERTHUS, options } = ConfigAxios();
  return axios.put(NERTHUS + '/inbursa/inbursaUsers/' + dataClientId, dataClient, options);
};

const deleteUser = dataClientId => {
  let { NERTHUS, options } = ConfigAxios();
  return axios.delete(NERTHUS + '/inbursa/inbursaUsers/' + dataClientId, options);
};

const setActiveAdvisor = (dataClientId, data) => {
  let { NERTHUS, options } = ConfigAxios();
  return axios.put(NERTHUS + '/inbursa/inbursaUsers/setActiveAdvisor/' + dataClientId, data, options);
};

const InbursaUsersCrudService = {
  getAllUsers,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
  setActiveAdvisor
};

export default InbursaUsersCrudService;